import { useSelector } from 'react-redux';

const selectShowEventMapOnSidePanel = (state) => state.ui.sidePanel.eventMap;

export function useShowEventMapOnSidePanel() {
    return useSelector(selectShowEventMapOnSidePanel);
}
